import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const MortgageFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4955901' height='600' />
}

export default React.memo(MortgageFormBlock)
